import styled, { css } from 'styled-components';

import colors from 'app/styles/theme/colors';
import { Footer } from 'app/components/DialogFooterButtons/styles';

const { gray } = colors.designSystem;

// Moldura de modal do design system (`.modal-shell`/`.modal-head`/`.modal-body`/
// `.modal-foot`): a largura do paper é de cada consumidor, o resto é igual.
export const dialogPaper = css`
  max-width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 10%), 0 8px 10px -6px rgb(0 0 0 / 10%);
`;

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 28px 8px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${gray[950]};
`;

export const Description = styled.p`
  margin: 6px 0 0;
  font-size: 14px;
  color: ${gray[700]};
`;

export const Body = styled.div`
  padding: 8px 28px 24px;
  overflow-y: auto;
`;

export const Foot = styled(Footer)`
  padding: 16px 28px;
  border-top: 1px solid ${gray[200]};
  background-color: ${gray[100]};
`;

export const ResultState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 24px;
  text-align: center;

  svg {
    font-size: 48px;
  }
`;

export const ResultIcon = styled.div<{ $variant: 'success' | 'error' }>`
  display: flex;
  color: ${({ $variant }) => ($variant === 'success' ? colors.designSystem.green[500] : colors.red.quinary)};
`;

export const ResultTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${gray[950]};
`;

export const ResultMessage = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${gray[700]};
`;
